/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Zahlungausgesetztbis2Inputs */

const de__field_zahlungausgesetztbis2 = /** @type {(inputs: _Field_Zahlungausgesetztbis2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlung ausgesetzt bis`)
};

/**

* @param {_Field_Zahlungausgesetztbis2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_zahlungausgesetztbis2 = /** @type {((inputs?: _Field_Zahlungausgesetztbis2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Zahlungausgesetztbis2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_zahlungausgesetztbis2(inputs)
});
export { _field_zahlungausgesetztbis2 as "_field_zahlungAusgesetztBis" }